import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from 'app/services/auth.service';

@Injectable()
export class EmailVerificationResolverService {
  public constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<void> {
    const code = route.paramMap.get('verificationCode');
    return this.authService.verifyEmail(code ?? 'invalid').pipe(
      catchError(async () => {
        await this.router.navigate(['404']);
      }),
    );
  }
}
